import React from "react";
import {FmlxButton, FmlxIcon} from "fmlx-common-ui";
import {FMLX_BUTTON, FMLX_COMPONENT} from "../../../const/FmlxComponentEnum";
import {useManageQuestionContext} from "../../../lib/contexLib";

const AddQuestions = ({handleAddQuestion}) => {
  const {renameTabId, selectedDepartment} = useManageQuestionContext();

  if (!selectedDepartment) {
    return null;
  }

  return (
    <div className="right_buttons" key={"rightButtonAction"}>
      <FmlxButton
        id="btnAddQuestion"
        size={FMLX_COMPONENT.SIZE.L}
        type={FMLX_BUTTON.TYPE.PRIMARY}
        variant={FMLX_BUTTON.VARIANT.CONTAIN}
        onClick={handleAddQuestion}
        icon={<FmlxIcon name="AddCircle" />}
        onlyIcon={true}
        withTooltip={true}
        tooltipDescription="Add New Question"
        tooltipPlacement="top"
        disabled={renameTabId !== null}
      />
      {/* hide button copy because not use */}
      {/* <FmlxButton
        id={"btnCopyQuestion"}
        size={FMLX_COMPONENT.SIZE.L}
        type={FMLX_BUTTON.TYPE.BASIC}
        variant={FMLX_BUTTON.VARIANT.PLAIN}
        icon={<FmlxIcon name={"ContentCopy"} />}
        onlyIcon={true}
        withTooltip={false}
      ></FmlxButton> */}
    </div>
  );
};

export default AddQuestions;
